import PermissionsAccessSection from '../../../sections/AdminDashboard/Configuration/PermissionsAccess';

const PermissionsAccess = () => <PermissionsAccessSection />;

export default PermissionsAccess;
